import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setProfileField } from '../modules/profile/actions';

/**
 * Ersetzt das frühere ProfileContext-Objekt eins zu eins (gleiche Feldnamen),
 * damit bestehende Konsumenten unverändert `profile.xxx`/`profile.setXxx(...)` nutzen können.
 *
 * Die Setter sind mit useCallback memoisiert, damit sie über Renders hinweg
 * referenzstabil bleiben - siehe useTreeState.js fuer die Begruendung
 * (sonst droht eine Endlosschleife, wenn ein Setter in einer Effekt-Dependency landet).
 */
export function useProfileState() {
    const profile = useSelector((state) => state.profile);
    const dispatch = useDispatch();

    const setProfiles = useCallback((value) => dispatch(setProfileField('profiles', value)), [dispatch]);
    const setClicked = useCallback((value) => dispatch(setProfileField('clicked', value)), [dispatch]);
    const setIsLoaded = useCallback((value) => dispatch(setProfileField('isLoaded', value)), [dispatch]);
    const setSelected = useCallback((value) => dispatch(setProfileField('selected', value)), [dispatch]);
    const setSelectedData = useCallback((value) => dispatch(setProfileField('selectedData', value)), [dispatch]);

    return {
        profiles: profile.profiles, setProfiles,
        clicked: profile.clicked, setClicked,
        isLoaded: profile.isLoaded, setIsLoaded,
        selected: profile.selected, setSelected,
        selectedData: profile.selectedData, setSelectedData,
    };
}
